<template>
  <th data-align="center" data-column-id="e" data-formatter="e" data-sortable="false" data-width="36px" title="Editar" data-header-no-icon="true">...</th>
</template>

<script>
export default {
  name: 'EditHeader'
}
</script>
